import { useCallback, useEffect, useState } from 'react'
import { useCountdown } from 'usehooks-ts'

const TOTAL_TIME = 300

export const useNonAuthSession = () => {
  const [isFreeSessionRunning, setIsFreeSessionRunning] = useState(false)
  const [value, setValue] = useState(TOTAL_TIME)

  const [count, { startCountdown, stopCountdown }] = useCountdown({
    countStart: value,
    intervalMs: 1000,
  })

  const handleStartCountdown = useCallback(() => {
    setIsFreeSessionRunning(true)
    startCountdown()
  }, [startCountdown])

  const handleStopCountdown = useCallback(() => {
    setIsFreeSessionRunning(false)
    stopCountdown()
  }, [count, stopCountdown, setValue])

  useEffect(() => {
    setValue(count)
  }, [count])

  return {
    freeTimeLeft: count,
    isFreeSessionRunning,
    startCountdown: handleStartCountdown,
    stopCountdown: handleStopCountdown,
  }
}
